import { Component } from '@angular/core';

@Component({
  selector: 'empathy-single-choice-description',
  templateUrl: 'single-choice-description.component.html',
  styleUrls: ['./single-choice-description.component.scss']
})
export class SingleChoiceDescriptionComponent {}
